import classNames from "classnames";
import React, { useState } from "react";
import { SeshTextRawInput } from "./sesh_text_raw_input";
import { SeshTextInput } from "./sesh_text_input";
import { RemovingThrobber } from "../../removing_throbber";

export function SeshSearchForm(props: {
	onSubmit: (str: string) => void;
	placeholder?: string;
}) {
	const [value, setValue] = useState("");

	return (
		<SeshTextSearchInput
			onSubmit={() => props.onSubmit(value)}
			handleChange={(str) => setValue(str)}
			handleClear={() => {
				setValue("");
				props.onSubmit("");
			}}
			input_props={{
				value: value,
				placeholder: props.placeholder,
			}}
		/>
	);
}

export function SeshTextSearchInput(
	props: React.ComponentProps<typeof SeshTextInput> & {
		is_loading?: boolean;
		onSubmit: () => void;
		handleChange: (str: string) => void;
		handleClear?: () => void;
	}
) {
	return (
		<form
			onSubmit={(e) => {
				e.preventDefault();
				props?.onSubmit();
			}}
		>
			<SeshTextInput
				{...props}
				input_element_override={
					<SeshTextRawInput
						{...props.input_props}
						onChange={(e) =>
							props.handleChange(e.currentTarget.value)
						}
						right_children={(is_hovered, is_focused) => (
							<div className="flex h-full items-center">
								{props.handleClear && (
									<div
										aria-label="Clear Search"
										title="Clear Search"
										className={classNames(
											"mx-2 cursor-pointer opacity-20 hover:opacity-100"
										)}
										onClick={() => props.handleClear()}
									>
										<i className="fas fa-times"></i>
									</div>
								)}
								<SeshTextSearchButton
									is_hovered={is_hovered}
									is_focused={is_focused}
									is_loading={props.is_loading}
								/>
							</div>
						)}
					/>
				}
			/>
		</form>
	);
}

function SeshTextSearchButton(props: {
	is_focused: boolean;
	is_hovered: boolean;
	is_loading?: boolean;
}) {
	return (
		<button
			type="submit"
			className={classNames(
				"flex h-full items-center border-l-2 px-2 hover:bg-base-light",
				{
					"border-sesh-primary": props.is_focused,
					"border-sesh-dark": props.is_hovered && !props.is_focused,
					"border-content-secondary":
						!props.is_focused && !props.is_hovered,
					"is-loading": props.is_loading,
				}
			)}
		>
			{props.is_loading && <RemovingThrobber />}
			{!props.is_loading && <i className="fas fa-search" />}
		</button>
	);
}
